<div class="pnf">
  <div class="pnf__content">
    <div class="pnf__left">
      <div class="pnf__logo">
        <img src="../../../../assets/images/havrion-white.svg" alt="Havrion" class="pnf__logo-img" />
      </div>
      <div class="pnf__code">404</div>
      <h1 class="pnf__title">Page not found</h1>
      <p class="pnf__subtitle">The URL you requested does not exist or you don't have permission to access it.</p>
      <button class="pnf__btn" (click)="return()">
        <span class="material-symbols-outlined">arrow_back</span>
        Go Back
      </button>
    </div>
    <div class="pnf__right">
      <img
        src="../../../../assets/images/404-image.png"
        alt="404"
        class="pnf__image"
      />
    </div>
  </div>
</div>
